// IE必须加es6-promise/lib/polyfill
// TODO 异步加载
// require('es6-promise').polyfill()
import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import api from './api'
import me from './me'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'
Vue.config.debug = debug

export default new Vuex.Store({
  modules: {
    api,
    me
  },
  state: {
    localBaseUrl: 'http://localhost/nutspie/dartcome-web',
    env: window.location.hostname.match('dartcome.com') ? 'prod' : 'dev'
  },
  getters: {
    rootDomain: state => state.env === 'prod' ? 'com' : 'nutsb.com'
  },
  strict: debug,
  plugins: process.env.NODE_ENV !== 'production'
    ? [createLogger()]
    : []
})



// WEBPACK FOOTER //
// ./src/store/store.js